import { Social, Wallet } from '../types';

export function isWallet(wallet: any): wallet is Wallet {
  return wallet && (wallet as Wallet).signedBytes !== undefined;
}

export function isSocial(social: any): social is Social {
  return social && (social as Social).social !== undefined;
}
